import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div
      className={classes.root}
      style={{
        width: isOpen
          ? sidebarConfig.drawerWidthOpen
          : sidebarConfig.drawerWidthClosed,
      }}
    >
      <Link
        to="/"
        underline="none"
        className={classes.link}
        style={
          isOpen
            ? { justifyContent: 'flex-start', paddingLeft: 24, paddingRight: 24 }
            : { justifyContent: 'center' }
        }
        aria-label="Home"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
